module.exports = __webpack_public_path__ + "static/media/21ECLAC45.95d072b1.jpg";